import { useNode } from '@craftjs/core';
import { upperFirst } from 'lodash';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useCallback, useMemo } from 'react';
import {
	AutocompleteControl,
	SliderControl,
	SwitchControl,
	TextControl
} from '../../settingsComponents';
import {
	colorOptions,
	sizeOptions,
	variantProps
} from './editorButtonConstants';

const EditorButtonBaseSettings = () => {
	const {
		children,
		size,
		variant,
		color,
		fullWidth,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [
		onChildrenChange,
		onVariantChange,
		onSizeChange,
		onColorChange,
		onFullWidthChange,
		onShapeChange
	] = useMemo(
		() =>
			[
				'children',
				'variant',
				'size',
				'color',
				'fullWidth',
				'shape',
				'formNoValidate'
			].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	const handleChildrenChange = useCallback(
		(value: string) => {
			onChildrenChange(value);
			onShapeChange(!value ? 'square' : '');
		},
		[onChildrenChange, onShapeChange]
	);

	return (
		<div>
			<TextControl
				value={children}
				label={intl.tr('screenEditor.settings.text')}
				setValue={handleChildrenChange}
			/>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.button.variant')}
				setValue={onVariantChange}
				value={variant}
				options={variantProps}
				getOptionLabel={(o: string) => upperFirst(o as string)}
			/>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.color')}
				setValue={onColorChange}
				value={color}
				options={colorOptions}
				getOptionLabel={(o: string) => upperFirst(o as string)}
			/>
			<SliderControl
				label={intl.tr('screenEditor.settings.button.size')}
				value={size}
				options={sizeOptions}
				setValue={onSizeChange}
				marks
			/>
			<SwitchControl
				value={fullWidth}
				setValue={onFullWidthChange}
				label={intl.tr('screenEditor.settings.fullWidth')}
			/>
		</div>
	);
};

export { EditorButtonBaseSettings };
